import { render } from "./CarbonForm.vue?vue&type=template&id=d27ba878&scoped=true"
import script from "./CarbonForm.vue?vue&type=script&lang=js"
export * from "./CarbonForm.vue?vue&type=script&lang=js"

import "./CarbonForm.vue?vue&type=style&index=0&id=d27ba878&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d27ba878"]])

export default __exports__